export const open_test_dialog = (cluster_id) => dispatch => {
    dispatch({
        type: "OPEN_TEST_DIALOG",
        cluster_id: cluster_id
    });
};

export const close_test_dialog = () => dispatch => {
    dispatch({
        type: "CLOSE_TEST_DIALOG"
    });
};

export const set_source_col = (source_col) => dispatch => {
    dispatch({
        type: "SET_SOURCE_COL",
        source_col: source_col
    });
};
export const set_target_col = (target_col) => dispatch => {
    dispatch({
        type: "SET_TARGET_COL",
        target_col: target_col
    });
};

export const set_target_col2 = (target_col2) => dispatch => {
    dispatch({
        type: "SET_TARGET_COL2",
        target_col2: target_col2
    });
};

export const set_col_names = (col_names) => dispatch => {
    dispatch({
        type: "SET_COL_NAMES",
        col_names
    });
};


export const reset_test = () => dispatch => {
    dispatch({
        type: "RESET_TEST"
    });
};
export const init_questions = (rows) => dispatch => {
    dispatch({
        type: "INIT_QUESTIONS",
        rows: rows
    });
};
export const set_questions = (rows) => dispatch => {
    dispatch({
        type: "SET_QUESTIONS",
        rows: rows
    });
};
export const next_question = () => dispatch => {
    dispatch({
        type: "NEXT_QUESTION"
    });
};
export const score_answer = (score) => dispatch => {
    dispatch({
        type: "SCORE_ANSWER",
        score
    });
};

export const set_character_boxes_visibility = (visible) => dispatch => {
    dispatch({
        type: "SET_CHARACTER_BOXES_VISIBILITY",
        visible
    });
};

export const set_randomize_row_order = (randomize) => dispatch => {
    dispatch({
        type: "SET_RANDOMIZE_ROW_ORDER",
        randomize
    });
};

export const set_case_sensitivity = (activate) => dispatch => {
    dispatch({
        type: "SET_CASE_SENSITIVITY",
        activate
    });
};

export const set_test_type = (value) => dispatch => {
    dispatch({
        type: "SET_TEST_TYPE",
        value
    });
};

export const set_time_for_answer = (timing) => dispatch => {
    timing = parseInt(timing);
    if (isNaN(timing) || timing < 1) {
        timing = null;
    }
    dispatch({
        type: "SET_TIME_FOR_ANSWER",
        timing: timing
    });
};
export const set_from_last_answers = (from_last_answers) => dispatch => {
    dispatch({
        type: "SET_FROM_LAST_ANSWERS",
        from_last_answers
    });
};

export const set_answer = (answer) => dispatch => {
    dispatch({
        type: "SET_ANSWER",
        answer
    });
};

export const set_answer2 = (answer) => dispatch => {
    dispatch({
        type: "SET_ANSWER2",
        answer
    });
};

export const start_test = () => dispatch => {
    dispatch({
        type: "START_TEST"
    });
};
export const finish_test = () => dispatch => {
    dispatch({
        type: "FINISH_TEST"
    });
};
export const pause_test = () => dispatch => {
    dispatch({
        type: "PAUSE_TEST"
    });
};
export const resume_test = () => dispatch => {
    dispatch({
        type: "RESUME_TEST"
    });
};

export const start_timer = (baseTime = 0) => dispatch => {
    dispatch({
        type: "START_TIMER",
        baseTime: baseTime,
        now: new Date().getTime()
    });
};

export const stop_timer = () => dispatch => {
    dispatch({
        type: "STOP_TIMER",
        now: new Date().getTime()
    });
};

export const reset_timer = () => dispatch => {
    dispatch({
        type: "RESET_TIMER",
        now: new Date().getTime()
    });
};

export const store_wrong_answers = (cluster_id, answers) => dispatch => {
    dispatch({
        type: "STORE_WRONG_ANSWERS",
        cluster_id: cluster_id,
        answers: answers
    });
};

export const TEST = {
    NOT_RUNNING: 0,
    RUNNING: 1,
    FINISHED: 2,
    PAUSED: 3
};
